import '@/assets/scss/v2/main.scss';
// Auth
import { startup as authStartup } from '@/core/auth';
/**
 * Imports Mixins
 */
import { commonMixin } from '@/modules/common/mixins/common.mixin';
import { userMixin } from '@/modules/user/mixins/user.mixins';
import datePlugin from '@/plugin/date.plugin';
import httpPlugin from '@/plugin/http.plugin';
import filterUtils, {
  date,
  hour,
  appointmentFormat,
  phone,
  dateTime,
  time,
  thousandsSeparator,
} from '@/utils/filters';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/l10n/es.js';
import PortalVue from 'portal-vue';
import Vue from 'vue';
import flatPickr from 'vue-flatpickr-component';
import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import vSelect from 'vue-select';
import moment from 'moment';
import 'moment/locale/es-do';
moment.locale('es-do');
/** End Import Plugins */
import VueJWT from 'vuejs-jwt';
import goodTableCustomPager from '../src/components/common/goodTableCustomPager.vue';
import App from './App.vue';
/** Plugins */
import './plugin/boostrap-vue';
import './plugin/vee-validate';
import './registerServiceWorker';
import router from './router';
import store from './store';
Vue.use(PortalVue);

/**
 * Setup Mixins
 */
import '@/mixin/vue-alerts';
Vue.mixin(commonMixin);
Vue.mixin(userMixin);

const $ = require('jquery');
window.$ = $;

Vue.use(httpPlugin);
Vue.use(datePlugin);
Vue.use(filterUtils);
Vue.use(VueJWT);
Vue.use(VueGoodTablePlugin);

Vue.component('v-select', vSelect);
Vue.component('customPager', goodTableCustomPager);
Vue.component('flatPickr', flatPickr);
Vue.filter('capitalize', function(value) {
  if (!value) return '';
  value = value.toString();

  return value
    .toLowerCase()
    .split(' ')
    .map((w) => w.substring(0, 1).toUpperCase() + w.substring(1))
    .join(' '); //value.toLowerCase().split(' ').map(word=> word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
});
Vue.filter('phone', phone);
Vue.filter('date', date);
Vue.filter('hour', hour);
Vue.filter('appointmentFormat', appointmentFormat);
Vue.filter('dateTime', dateTime);
Vue.filter('thousandsSeparator', thousandsSeparator);
Vue.filter('time', time);
Vue.config.productionTip = false;

store.watch(
  (state) => state.$_student.selectedStudent,
  (newValue, oldValue) => {
    //Problem with ID

    if (oldValue && JSON.stringify(newValue) != JSON.stringify(oldValue)) {
      if (!newValue || oldValue.studentId == newValue.studentId) {
        return;
      }

      if (!store.state.bypassStudentChangeAlert) {
        store.dispatch('canChangeStudent');
      } else {
        store.state.bypassStudentChangeAlert = null;
      }

      // clear the studentPreRegistry when selecting another student
      store.commit('$_student/setStudentPreRegistry', {});

      //cambiar el metodo del boton
      store.commit('setSaveChange', () => {
        store.dispatch('RedirectRouter', router.currentRoute);
      });
    }
  }
);

authStartup().then((ok) => {
  if (ok) {
    new Vue({
      store,
      router,
      render: (h) => h(App),
      mounted() {
        if (this.isTrainingEnv()) {
          const favicon = $('#favicon');
          favicon.attr('href', '/favicon-training.ico');
        }
      },
    }).$mount('#app');
  }
});
